import request from '@/plugin/axios'
/*
** 获取未停用的 项目名称、承运单位
*/
export function firsOjbName (searchStr, type) {
  return request({
    url: '/basic/basiclist/payobjlist',
    method: 'get',
    params: { searchStr: searchStr, searchType: type }
  })
}

export function haireOjbName (searchStr, type) {
  return request({
    url: '/tms/comlist/haire/OjbName',
    method: 'get',
    params: { searchStr: searchStr, type: type }
  })
}

export function qkation (searchStr) {
  return request({
    url: '/basic/basiclist/pro/qkation',
    method: 'get',
    params: { searchStr: searchStr }
  })
}
/*
** 获取所有的（包括停用的） 项目名称、承运单位
*/
export function firsOjbNameAll (searchStr, type) {
  return request({
    url: '/basic/basiclist/payobjlist',
    method: 'get',
    params: { searchStr: searchStr, searchType: type }
  })
}
